<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="center-para"><a id="page_i"></a><em>Praise for</em></p>
<p class="center-para"><strong>L. A. BANKS</strong><br/>&amp;<br/><em>The Vampire Huntress Legend series</em></p>
<p class="para"> </p>
<p class="center-para">THE WICKED</p>
<p class="para"> </p>
<p class="para">“A complex world of good vs. evil . . . The story is so compelling, the whole series must be read.”</p>
<p class="right-para"><em>—Birmingham Times</em></p>
<p class="linespace"> </p>
<p class="center-para">THE CURSED</p>
<p class="para"> </p>
<p class="para">“A wild amalgam of Christianity, vampire lore, world myth, functional morality, street philosophy, and hot sex . . . Fans couldn’t ask for more.”</p>
<p class="right-para"><em>—Publishers Weekly</em></p>
<p class="linespace"> </p>
<p class="center-para">THE FORSAKEN</p>
<p class="para"> </p>
<p class="para">“Readers already enthralled with this sizzling series can look forward to major plot payoffs.”</p>
<p class="right-para"><em>—Publishers Weekly</em></p>
<p class="linespace"> </p>
<p class="center-para">THE DAMNED</p>
<p class="para"> </p>
<p class="para">“All hell breaks loose—literally—in the complex sixth installment . . . stunning.”</p>
<p class="right-para"><em>—Publishers Weekly</em></p>
<p class="linespace"> </p>
<p class="center-para">THE FORBIDDEN</p>
<p class="para"> </p>
<p class="para">“Passion, mythology, war and love that lasts till the grave-and beyond . . . Fans should relish this new chapter in a promising series.”</p>
<p class="right-para">—<em>Publishers Weekly</em></p>
<p class="linespace"> </p>
<p class="right-para"><span class="smallcaps">MORE . . .</span></p>
<p class="para"> </p>
<p class="para"><a id="page_ii"></a>“Superior vampire fiction.”</p>
<p class="right-para"><em>—Booklist</em></p>
<p class="para"> </p>
<p class="para">“Gripping.”</p>
<p class="right-para"><em>—Kirkus Reviews</em></p>
<p class="linespace"> </p>
<p class="center-para">THE BITTEN</p>
<p class="para"> </p>
<p class="para">“Seductive . . . mixing religion with erotic horror dosed with a funky African-American beat, Banks blithely piles on layer after layer of densely detailed plot . . . [that] will delight established fans. Banks creates smokin’ sex scenes that easily out-vamp Laurell K. Hamilton’s.”</p>
<p class="right-para"><em>—Publishers Weekly</em></p>
<p class="para"> </p>
<p class="para">“The stakes have never been higher, and the excitement and tension are palpable in this installment of Banks’ complex, sexy series.”</p>
<p class="right-para"><em>—Booklist</em></p>
<p class="para"> </p>
<p class="para">“The storyline and the action are intense, and this book is a page-turner that showcases Ms. Banks’ writing to perfection. While the storyline is fascinating, the characters make this series one of the most enjoyable I have ever read . . . unforgettable, toe-curling love scenes . . . an excellent read. Ms. Banks has written a book of passion, romance, action, horror and intrigue. Sit back, hold on and enjoy the ride!”</p>
<p class="right-para"><em>—Romance in Color</em></p>
<p class="linespace"> </p>
<p class="center-para">THE HUNTED</p>
<p class="para"> </p>
<p class="para">“A terrifying roller-coaster ride of a book.”</p>
<p class="right-para">—Charlaine Harris</p>
<p class="para"> </p>
<p class="para">“A spellbinding thrill ride.”</p>
<p class="right-para">—Zane</p>
<p class="para"> </p>
<p class="para">“The well-conceived and intricate rules of Banks’ vampire-inhabited world provide endless opportunities for riffs on the meaning of power and sex that will please lovers of similar . . . philosophical musings found in the vampire tales of Anne Rice and Laurell K. Hamilton.”</p>
<p class="right-para"><em>—Publishers Weekly</em></p>
<p class="para"><a id="page_iii"></a>“Hip, fresh, and fantastic.”</p>
<p class="right-para">—Sherrilyn Kenyon,<br/><em>New York Times</em> bestselling author of<br/><em>Dark Side of the Moon</em></p>
<p class="para"> </p>
<p class="center-para">THE AWAKENING</p>
<p class="para"> </p>
<p class="para">“An intriguing portrait of vampiric society, reminiscent of Anne Rice and Laurell K. Hamilton.”</p>
<p class="right-para"><em>—Library Journal</em></p>
<p class="para"> </p>
<p class="para">“With <em>The Awakening</em>, Banks solidifies her intriguing, dark series as a project worth watching.”</p>
<p class="right-para"><em>—Booklist</em></p>
<p class="para"> </p>
<p class="para">“Again, Banks brilliantly combines spirituality, vampires, and demons (and hip-hop music) into a fast-paced tale that is sure to leave fans of her first novel, <em>Minion</em>, panting for more.”</p>
<p class="right-para"><em>—Columbus Dispatch</em></p>
<p class="linespace"> </p>
<p class="center-para">MINION</p>
<p class="para"> </p>
<p class="para">“Banks’ mastery of character creation shines through in the strong-willed Damali . . . a sure-fire hit . . . pretty dramatic fiction.”</p>
<p class="right-para"><em>—Philadelphia Daily News</em></p>
<p class="para"> </p>
<p class="para">“[<em>Minion</em>] literally rocks the reader into the action-packed underworld power struggle between vampire rivals with a little demon juice thrown in.”</p>
<p class="right-para"><em>—Philadelphia Sunday Sun</em></p>
<p class="para"> </p>
<p class="para">“Banks [is] wildly creative and invents a totally new and refreshing milieu.”</p>
<p class="right-para"><em>—Fangoria</em></p>
<p class="para"> </p>
<p class="para">“[A] tough, sexy new vampire huntress challenges the dominance of Anita Blake and Buffy . . . Damali is an appealing heroine, the concept is intriguing, and the series promising.”</p>
<p class="right-para">—Amazon.com</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abouttheauthor.vue?5c69bd44